import { Components, Theme } from "@mui/material";

declare module "@mui/material/Select" {}

export const MuiSelect: Components<Theme>["MuiSelect"] = {
  styleOverrides: {
    root: {
      background: "white",
    },
  },
};
